export default __webpack_public_path__ + "static/media/gsap.f1eb67ea.svg";